import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "@design-system/tokens/breakpoints.css";
import "@design-system/tokens/colors.css";
import "@design-system/tokens/fonts.css";

// Must load before App so Sentry.init runs before wrapCreateBrowserRouter.
import { Sentry } from "./sentry";
import App from "./App.tsx";
import { ThemedToastContainer } from "./components/ThemedToastContainer";
import { redirectToLocalhost } from "./utils/redirectToLocalhost";

import "./index.css";
import "react-loading-skeleton/dist/skeleton.css";

// Redirect to localhost in development when accessing from whitelisted hosts
redirectToLocalhost();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Sentry.ErrorBoundary
      fallback={
        <div style={{ padding: 24 }}>
          Something went wrong. Please reload the page.
        </div>
      }
    >
      <App />
      <ThemedToastContainer />
    </Sentry.ErrorBoundary>
  </StrictMode>,
);
